import { FC, Ref } from 'react';

import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { ModalApi } from '@components/Modal';
import Input from '@components/Input';
import { ZubizuIcon, BaseCheckIcon } from '@assets/icons';
import { Col } from '@components/formStyles';
import CustomIcon from '@components/utils/CustomIcon';

import {
  DynamicDiv,
  Section,
  StyledButton,
  StyledFlexibleDiv,
  LogoWrapper,
  MainWrapper,
  Bold,
  ButtonWrapper,
  Paragraph,
  Content,
  HopiWrapper,
} from './styled';
import { ZubizuSchema } from '../../schemas';
import PromotionModal from '..';

const staticButtonStyle = {
  width: 147,
  height: 68,
};

const staticProps = {
  width: 674,
  title: 'Zubizu Hesap Doğrulama',
  promotionTitle: 'Zubizu Nedir?',
  promotionDescription:
    'Alışverişin app’i Zubizu; zevklerini, alışveriş alışkanlıklarını öğrenir ve istediğin ürünlere kolayca ulaşmanı sağlar. Hiçbir yerde olmayan kampanyalarıyla alışverişlerinde sana Paracık kazandırır.',
};

const initialValues = {
  zubizuCode: '',
};

export interface ZubizuModalFormData {
  zubizuCode: string;
}

const ZubizuModal: FC<{
  modal?: Ref<ModalApi>;
  isVisible?: boolean;
  isValided?: boolean;
  onCancel?: () => void;
  onSubmit: (formData: ZubizuModalFormData) => void;
}> = ({ modal, isVisible, isValided = false, onCancel, onSubmit, ...rest }) => {
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm<ZubizuModalFormData>({
    defaultValues: initialValues,
    resolver: yupResolver(ZubizuSchema),
  });

  return (
    <PromotionModal
      modal={modal}
      isVisible={isVisible}
      onCancel={onCancel}
      {...staticProps}
      {...rest}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <DynamicDiv>
          <Content>
            <DynamicDiv spaceBetween>
              <MainWrapper>
                <Col>
                  <LogoWrapper>
                    <CustomIcon icon={ZubizuIcon} width={100} height={80} />
                  </LogoWrapper>

                  <Section>
                    <Paragraph>
                      <Bold>Zubizu</Bold>n varsa kampanyalardan yararlanmak ve
                      <Bold> Paracık</Bold>
                      larınla alışveriş yapmak için aşağıya
                      <Bold> Zubizu Kodunu gir.</Bold>
                    </Paragraph>
                  </Section>

                  <MainWrapper>
                    <Section>
                      <StyledFlexibleDiv top={-20}>
                        <DynamicDiv>
                          <Controller
                            control={control}
                            name='zubizuCode'
                            render={({ field }) => (
                              <Input
                                {...field}
                                label='Zubizu Kodunu Gir'
                                hasError={Boolean(errors.zubizuCode)}
                              />
                            )}
                          />
                          <ButtonWrapper>
                            <StyledButton
                              style={staticButtonStyle}
                              disabled={isSubmitting}
                              outline
                              size='large'
                              htmlType='submit'
                              isValid={isValided}
                            >
                              <span>
                                {!isValided ? 'Doğrula' : 'Doğrulandı'}
                              </span>
                              <BaseCheckIcon width={24} height={24} />
                            </StyledButton>
                          </ButtonWrapper>
                        </DynamicDiv>
                      </StyledFlexibleDiv>
                    </Section>
                  </MainWrapper>
                </Col>
              </MainWrapper>

              <HopiWrapper>
                <Col>
                  <Section>
                    <img
                      width='125'
                      alt='zubizu'
                      src='/static/images/hopi-phone.webp'
                    />
                  </Section>
                </Col>
              </HopiWrapper>
            </DynamicDiv>
          </Content>
        </DynamicDiv>
      </form>
    </PromotionModal>
  );
};

export default ZubizuModal;
